const textValidationFn = (label, isRequired) => (value) => {
  if (isRequired) {
    if (!value || value === '') {
      return `${label} is required.`;
    } else if (value.length < 3) {
      return `${label} must have a minimum of 3 characters.`;
    }
  }
  return null;
};

export default textValidationFn;
